import { ApiError } from '@/lib/api';
import { toErrorMessage } from '@reflex/plugin-api/errors';

/**
 * The actionable alert rendered under the provider buttons when a local dev
 * sign-in fails. Extracted into its own module so `AuthScreen.tsx` can stay a
 * pure component file (eslint `react-refresh/only-export-components`).
 */
export interface DevLoginError {
  message: string;
  hint?: string;
}

/** Shape a failed dev sign-in into the actionable alert under the buttons. */
export function describeDevLoginError(err: unknown): DevLoginError {
  if (err instanceof ApiError) {
    const isEmptyResponse = err.message === `Request failed: ${err.status}`;
    return {
      message: isEmptyResponse
        ? 'Server did not respond. It may have crashed on startup.'
        : err.message,
      hint:
        err.hint ??
        (isEmptyResponse
          ? 'Check the server logs for startup errors. Common causes: missing .env file, database initialization failure, or invalid configuration.'
          : undefined),
    };
  }
  return { message: toErrorMessage(err) };
}
